<template>
  <div>
    <v-container fluid px-0 class="Container_Nivel2_Apuracao">
      <v-row align="center" justify="center" class="mx-0">
        <v-col cols="12">
          <v-text-field
            v-model="pesquisaCards"
            append-icon="search"
            @input="filtrar"
            :label="`${$tc('label.pesquisar', 1)}`"
            class="Barra_Pesquisa"
            single-line
            hide-details
            clearable>
          </v-text-field>
        </v-col>

        <v-container fluid grid-list-md v-if="lista.length">
          <v-data-iterator
            :items="lista"
            :options.sync="pagination"
            :hide-default-footer="12 >= totalPage"
            :server-items-length="totalPage"
            :footer-props="{
              itemsPerPageOptions: rowsPerPageItems,
            }">
            <template v-slot:default="props">
              <v-row justify="start">
                <v-col
                  v-for="item in props.items"
                  :key="item.cod_apuracao"
                  cols="12"
                  sm="4"
                  md="3">
                  <v-hover v-slot:default="{ hover }">
                    <v-card :class="`Card_${item.status_apuracao} elevation-${hover ? 5 : 1}`"
                            fill-height class="clickable Card_Apuracao">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-card-title class="Card_Title" v-on="on" @click="selectItem(item)">
                            <v-row justify="center" align="center">
                              <p style="text-align: center;">
                                {{ item.cod_acao }} - {{ item.cod_apuracao }}
                                <span v-if="isVisaoStatus && isOrigemOuFocoExtensao(item)">
                                  <br />{{ (item.origem_acao || item.foco_acao) | truncate(25) }}
                                </span>
                                <span v-if="isVisaoStatus && !isOrigemOuFocoExtensao(item)">
                                  <br />{{ item.titulo | truncate(25) }}
                                </span>
                                <span v-if="!isVisaoStatus">
                                  <br />{{ item.descricao_acao | truncate(25) }}
                                </span>
                              </p>
                            </v-row>
                          </v-card-title>
                        </template>
                        <div>
                          {{ $t('label.descricao') }}: {{ item.descricao_acao }}<br />
                          <span v-if="item.periodo_apuracao">
                            {{ $tc('label.periodo_apuracao', 1) }}: {{$tc(`periodo_apuracao.${item.periodo_apuracao.toLowerCase()}`, 1)}}<br />
                          </span>
                          {{ $t('label.status') }}: {{$tc(`status_entidade.${item.status_apuracao.toLowerCase()}`, 1)}}
                        </div>
                      </v-tooltip>
                      <v-card-text class="Card_Content py-0" @click="selectItem(item)">
                        <v-row justify="center" align="center">
                          <p nowrap class="headline font-weight-light">
                            {{ getMoney(item.vlr_conf_apuracao) }}
                          </p>
                        </v-row>
                      </v-card-text>
                      <v-card-actions class="Card_Actions">
                        <p class="mb-2 text-sm-body-2" justify="and" align="center">
                          {{ $t('label.tipo_acao') }}: {{item.tipo_acao}}
                        </p>
                        <apuracao-acao-fluxo
                            class="pa-3"
                            :observacaoAcao="item.observacao_acao"
                            :indJustificativaAnalise="item.ind_justificativa_analise"
                            :indHabilitaFluxo="item.ind_habilita_fluxo"
                            :indHabilitaEdicaoAprovacao="item.ind_habilita_edicao_aprovacao"
                            :acao="item.acao"
                            :idAcao="item.cod_acao"
                            :idApuracao="item.cod_apuracao"
                            :status="item.status_apuracao"
                            :vlr-conf-apuracao="item.vlr_conf_apuracao"
                            :vlr-conf-apuracao-original="item.vlr_conf_apuracao_original"
                            :vlr-reservado="item.vlr_reservado"
                            :valor-realizado="item.valor_realizado"
                            :qtd-contas-vinculadas="item.qtd_contas_vinculadas"
                            :pode-cancelar="item.pode_cancelar"
                            :pode-reprovar="item.pode_reprovar"
                            :is-fluxo-paralelo="item.is_fluxo_paralelo"
                            :exibir-solicitar-aprovacao="!item.bloqueio_aprovacao_sem_evidencia
                             && !item.bloqueio_liq_manual_sem_pagamento_aprovado"
                            :exibir-concluir-aprovacao="!item.bloqueio_aprovacao_sem_evidencia
                             && !item.bloqueio_liq_manual_sem_pagamento_aprovado"
                            :tipos-verbas="item.tipos_verbas"
                            :periodos-orcamentarios="item.periodos_orcamentarios"
                            @ApuracaoAcaoFluxo__recarregar="buscar()"
                            @ApuracaoFluxo__AusenciaSaldo="exibirMensagemSaldo"
                        />
                      </v-card-actions>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </template>
            <template v-slot:no-data>
              <v-row justify="center">
                {{ $t('label.tabela_sem_conteudo') }}
              </v-row>
            </template>
            <template v-slot:no-results>
              <v-row justify="center">
                {{ $t('label.tabela_sem_conteudo') }}
              </v-row>
            </template>
          </v-data-iterator>
        </v-container>
      </v-row>
    </v-container>
    <v-dialog
      v-model="exibeMensagemSaldo"
      max-width="600">
      <v-card>
        <v-card-title class="headline">{{ $t('title.atencao') }}</v-card-title>
        <v-card-text>
          {{ this.$t('message.saldo_insuficiente_conta', dadosValidacaoSaldo) }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"
            text
            @click="() => exibeMensagemSaldo = false">{{ $t('label.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ApuracaoAcaoFluxo from '@/spa/apuracao-acao/ApuracaoAcaoFluxo';
import {
  getMoney,
  getPercent,
} from '../../common/functions/helpers';
import { generateComputed } from '../../common/functions/roles-computed-generator';
import {
  listarApuracoesNivel2,
  listarApuracoesNivel2Simplificado,
} from '../../common/resources/apuracao/apuracao-acao-listagem';

export default {
  name: 'ApuracaoAcaoListNivel2',
  components: {
    ApuracaoAcaoFluxo,
  },
  data() {
    return {
      pesquisaCards: '',
      status: null,
      idFornecedor: null,
      idFornecedorPagador: null,
      idGrupoFornecedor: null,
      idCliente: null,
      idHolding: null,
      idExterno: null,
      idExtensao: null,
      idRegional: null,
      idAcaoProjeto: null,
      mnemonico: null,
      origem: null,
      acao: {},
      iteratorKey: 0,
      totalPage: 0,
      lista: [],
      filtrosAplicados: {},
      rowsPerPageItems: [12],
      pagination: {
        itemsPerPage: 12,
      },
      buscando: false,
      esperarDigitar: false,

      dadosValidacaoSaldo: null,
      exibeMensagemSaldo: false,
    };
  },
  watch: {
    filtroApuracaoAcao: {
      handler() {
        this.filtrosAplicados = this.filtroApuracaoAcao;
        this.buscar();
      },
    },
    pagination: {
      handler() {
        if (this.filtroApuracaoAcao) {
          this.buscar();
        }
      },
      deep: true,
    },
  },
  filters: {
    truncate(value, limit) {
      if (value && value.length > limit) {
        value = value.substring(0, (limit - 3)).concat('...');
      }
      return value;
    },
  },
  computed: {
    ...generateComputed('APU_ACAO', [
      'canAccessPage',
      'canAccessCRUD',
    ]),
    ...mapGetters('filtros', [
      'filtroApuracaoAcaoNivel2',
      'filtroApuracaoAcao',
    ]),
    ...mapGetters('implantacao', [
      'indModoVarejo',
    ]),
    isVisaoStatus() {
      return !!this.status;
    },

    isVisaoFornecedor() {
      return !!this.idFornecedor;
    },

    isVisaoFornecedorPagador() {
      return !!this.idFornecedorPagador;
    },

    isVisaoGrupoFornecedor() {
      return !!this.idGrupoFornecedor;
    },

    isVisaoCliente() {
      return !!this.idCliente;
    },

    isVisaoHolding() {
      return !!this.idHolding;
    },

    isVisaoRegional() {
      return !!this.idRegional;
    },

    isVisaoProjeto() {
      return !!this.idAcaoProjeto;
    },

    isVisaoExtensao() {
      return !!this.mnemonico && !!this.idExterno;
    },
  },
  methods: {
    getMoney,
    getPercent,
    ...mapActions('filtros', [
      'setFiltroApuracaoAcaoNivel2',
      'setFiltroApuracaoAcao',
      'setFiltroApuracaoAcaoNivel1',
    ]),
    exibirMensagemSaldo(dados) {
      this.dadosValidacaoSaldo = dados;
      this.exibeMensagemSaldo = true;
    },
    filtrar() {
      if (this.esperarDigitar) return;
      this.esperarDigitar = true;
      setTimeout(() => {
        this.esperarDigitar = false;
        this.buscar();
      }, 5E2);
    },
    selectItem(item) {
      this.consultar(listarApuracoesNivel2Simplificado, (response) => {
        const listaSimplificada = response.data;

        const params = {
          id: item.cod_apuracao,
          idAcao: item.cod_acao,
          apuracoes: listaSimplificada,
          from: 'apuracao-acao',
          fluxo: item.fluxo,
        };

        let query;

        if (this.isVisaoStatus) {
          params.status = this.status;
          this.$router.push({ name: 'detalharApuracaoAcaoStatus', params, query });
        }

        query = { origem: this.origem };

        if (this.isVisaoFornecedor) {
          params.idFornecedor = this.idFornecedor;
          this.$router.push({ name: 'detalharApuracaoAcaoFornecedor', params, query });
        }

        if (this.isVisaoFornecedorPagador) {
          params.idFornecedorPagador = this.idFornecedorPagador;
          this.$router.push({ name: 'detalharApuracaoAcaoFornecedorPagador', params, query });
        }

        if (this.isVisaoGrupoFornecedor) {
          params.idGrupoFornecedor = this.idGrupoFornecedor;
          this.$router.push({ name: 'detalharApuracaoAcaoGrupo', params, query });
        }

        if (this.isVisaoCliente) {
          params.idCliente = this.idCliente;
          this.$router.push({ name: 'detalharApuracaoAcaoCliente', params, query });
        }

        if (this.isVisaoHolding) {
          params.idHolding = this.idHolding;
          this.$router.push({ name: 'detalharApuracaoAcaoHolding', params, query });
        }

        if (this.isVisaoRegional) {
          params.idRegional = this.idRegional;
          this.$router.push({ name: 'detalharApuracaoAcaoRegional', params, query });
        }

        if (this.isVisaoExtensao) {
          params.mnemonico = this.mnemonico;
          params.idExterno = this.idExterno;
          this.$router.push({ name: 'detalharApuracaoAcaoExtensao', params, query });
        }

        if (this.isVisaoProjeto) {
          params.idAcaoProjeto = this.idAcaoProjeto;
          this.$router.push({ name: 'detalharApuracaoAcaoProjeto', params, query });
        }
      });
    },
    buscar() {
      this.consultar(listarApuracoesNivel2, (response) => {
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.lista = response.data.resposta;
        if (this.lista.length === 0) {
          this.setFiltroApuracaoAcao({});
          this.setFiltroApuracaoAcaoNivel1({});
          setTimeout(() => {
            this.$router.push({ name: 'apuracao-acao' });
          });
          return;
        }

        this.lista.forEach((i) => {
          i.acao = {};
          i.acao.idAcao = i.cod_acao;
          i.acao.idApuracao = i.cod_apuracao;
          i.acao.fluxo = JSON.parse(i.fluxo.value);
          i.acao.tipo_acao = i.tipo_acao;
          const desAtributos = i.des_atributos
            ? JSON.parse(i.des_atributos.value) : {};
          i.acao = {
            ...i.acao,
            ...desAtributos,
            indValidaSaldoPendente: !!(i.ind_valida_saldo_pendente || i.indValidaSaldoPendente),
            valorAcao: i.valor_acao || i.valorAcao,
          };
        });
        this.rowsPerPageItems = [12, 24, 36, 48, 60, 72, 84];
        setTimeout(this.finalizandoBusca);
        this.preencherFiltrosNivel1Vuex();
      });
    },
    consultar(consulta, sucesso) {
      if (this.buscando) return;
      this.buscando = true;

      const params = {
        ...this.filtrosAplicados,
        filtro: this.pesquisaCards,
        tamanhoPagina: this.pagination.itemsPerPage,
        numeroPagina: this.pagination.page,
      };

      if (this.isVisaoFornecedor) {
        params.id_fornecedor = this.idFornecedor;
      } else if (this.isVisaoFornecedorPagador) {
        params.id_fornecedor_pagador = this.idFornecedorPagador;
      } else if (this.isVisaoGrupoFornecedor) {
        params.id_grupo_fornecedor = this.idGrupoFornecedor;
      } else if (this.isVisaoCliente) {
        params.id_cliente = this.idCliente;
      } else if (this.isVisaoHolding) {
        params.id_holding = this.idHolding;
      } else if (this.isVisaoStatus) {
        params.status = this.status;
      } else if (this.isVisaoRegional) {
        params.id_regional = this.idRegional;
      } else if (this.isVisaoProjeto) {
        params.id_acao_projeto = this.idAcaoProjeto;
      } else {
        params.id_externo = this.idExterno;
        params.mnemonico = this.mnemonico;
      }

      consulta(params, this.$resource)
        .then(sucesso)
        .catch((err) => {
          this.finalizandoBusca();
          this.$error(this, err);
        });
    },
    preencherFiltrosNivel2() {
      this.pagination.page = this.filtroApuracaoAcaoNivel2.pagina;
      this.pagination.itemsPerPage = this.filtroApuracaoAcaoNivel2.quantidatePorPagina;
    },
    preencherFiltrosNivel1Vuex() {
      const pagina = this.pagination.page;
      const quantidatePorPagina = this.pagination.itemsPerPage;

      this.setFiltroApuracaoAcaoNivel2({
        pagina,
        quantidatePorPagina,
      });
    },
    finalizandoBusca() {
      this.buscando = false;
      this.$forceUpdate();
    },
    preencherFiltrosRouter() {
      this.status = this.$route.params.status;
      this.idFornecedor = this.$route.params.idFornecedor;
      this.idFornecedorPagador = this.$route.params.idFornecedorPagador;
      this.idGrupoFornecedor = this.$route.params.idGrupoFornecedor;
      this.idCliente = this.$route.params.idCliente;
      this.idHolding = this.$route.params.idHolding;
      this.idExterno = this.$route.params.idExterno;
      this.idRegional = this.$route.params.idRegional;
      this.idExtensao = this.$route.params.idExtensao;
      this.mnemonico = this.$route.params.mnemonico;
      this.origem = this.$route.query.origem;
      this.idAcaoProjeto = this.$route.params.idAcaoProjeto;
    },
    isOrigemOuFocoExtensao(item) {
      if ((this.indModoVarejo && !item.is_origem_fornecedor)
         || (!this.indModoVarejo && !item.is_foco_cliente && !item.is_foco_regional)) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    this.preencherFiltrosRouter();
  },
  mounted() {
    if (this.filtroApuracaoAcaoNivel2) {
      this.preencherFiltrosNivel2();
    }
    if (this.filtroApuracaoAcao) {
      this.filtrosAplicados = this.filtroApuracaoAcao;
    }
    this.buscar();
  },
};
</script>

<style>
.Container_Nivel2_Apuracao .Card_Apuracao {
  min-height: 146px !important;
  height: 100%;
}
.Container_Nivel2_Apuracao .Card_Title, .Container_Nivel2_Apuracao .Card_Content {
  color: #757575;
}
.Container_Nivel2_Apuracao .Card_Actions {
  min-height: 33%;
}
.Barra_Pesquisa {
  width: 33%;
}
.clickable {
  cursor: pointer;
}
</style>
<style src="../../assets/css/card-status.css" lang="css"></style>
